import { AppProvider } from './providers';
import { AppRouter } from './routes';
import { ToastContainer } from '@/shared/components';
import '../index.css';

export function App() {
  return (
    <AppProvider>
      <AppRouter />
      <ToastContainer />
    </AppProvider>
  );
}

